<template>
  <div class="wrapper__popup">
    <div class="wrapper__popup__container animated bounceInDown">
      <button
        class="wrapper__btn wrapper__popup__go-back"
        @click="goBack()"
        v-trackevent:val="'expanded_popup_back-btn'"
      ></button>
    </div>
  </div>
</template>

<script>
    export default {

        name: 'PopUp',

        methods: {

            goBack() {
                this.$emit('back', false);
            }
        }
    }
</script>

<style scoped lang="scss">
  .wrapper__popup {
    align-items: center;
    background-color: rgba(252, 226, 58, .79);
    display: flex;
    height: 100vh;
    left: 0;
    position: fixed;
    top: 0;
    width: 100vw;
    z-index: 12;

    &__container {
      background-image: url('/images/popup.png');
      height: 557px;
      margin: 0px auto;
      width: 878px;
    }

    &__go-back {
        position: absolute;
        top: 478px;
        left: 72px;
        width: 298px;
        height: 74px;
    }
  }
</style>
